<template>
  <div>
    <div class="vx-row" v-if="deviceFrom.uid && mobile.length || !deviceFrom.uid && desktop.length">
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
        <vx-card>
          <div class="my-6 text-center">
            <i class="fas fa-mobile-alt fa-4x text-primary" v-show="deviceFrom.uid"></i>
            <i class="fas fa-desktop-alt fa-4x text-primary" v-show="!deviceFrom.uid"></i>

            <h5 class="m-4 mb-2">{{deviceFrom.alias || deviceFrom.device || 'Sem Apelido'}}</h5>

            <div v-if="!deviceFrom.licence.locked">
              <div>Este é o disposito do qual a licença será removida.</div>
              <div>O dispositivo não será excluído, mas os dados serão bloqueados.</div>
              <div>Será necessário assinar um plano novo para liberar o conteúdo.</div>
              <div class="mt-4 p-6 text-white bg-danger rounded">
                <h4 class="text-white mb-2">Atenção</h4>
                <div>
                  Quando a licença for transferida, você só conseguirá transferir
                  <br />a mesma licença novamente depois de 14 dias.
                </div>
              </div>
            </div>

            <div v-else>
              <div class="mt-4 p-6 text-white bg-danger rounded">
                <div>
                  A licença deste dispositivo só poderá ser transferida novamente após o dia
                  <strong>{{deviceFrom.licence.locked | formatDate}}</strong>.
                  <br />Caso precise transferir a licença antes deste prazo, entre em contato com o suporte.
                </div>
              </div>
            </div>
          </div>
        </vx-card>
      </div>
      <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
        <vx-card v-if="!deviceFrom.licence.locked">
          <div class="my-6 text-center">
            <i class="fas fa-mobile-alt fa-4x text-success" v-show="deviceFrom.uid"></i>
            <i class="fas fa-desktop-alt fa-4x text-success" v-show="!deviceFrom.uid"></i>
            <div class="mt-4">Selecione para qual dispositivo transferir a licença.</div>
            <div
              class="m-4 p-6 text-white bg-success rounded"
            >Você só pode transferir a licença para um aparelho sem licença.</div>

            <div v-if="deviceFrom.uid" class="p-5">
              <div class="flex" v-for="mobile in mobile" :key="mobile.uid">
                <div class="mr-4">
                  <input type="radio" name="to" :value="mobile.uid" v-model="deviceToUid" :id="`device-${mobile.uid}`" />
                </div>
                <label class :for="`device-${mobile.uid}`">{{mobile.alias || mobile.device}}</label>
              </div>
            </div>

            <vs-button
              color="success"
              class="w-full ml-4 mt-4 md:w-auto"
              :disabled="!deviceToUid || processing"
              @click="transfer()"
            >
              <i class="far fa-exchange"></i> Transferir
            </vs-button>
          </div>
        </vx-card>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      deviceFrom: {},
      deviceToUid: null,
      mobile: {},
      desktop: {},
      processing: false,
    };
  },
  mounted() {
    this.deviceFrom = JSON.parse(this.$localStorage.get("deviceTransfer"));

    // desktop
    this.$api
      .get("/api/v1/desktop/device")
      .then((response) => {
        this.desktop = response.data.data;
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: "Aviso",
          text: error.response.data.error || error.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });

    // mobile
    this.$api
      .get("/api/v1/mobile/device")
      .then((response) => {
        this.mobile = response.data.data.filter((m) => !m.licence.active);
      })
      .catch((error) => {
        this.$vs.notify({
          time: 6000,
          title: "Aviso",
          text: error.response.data.error || error.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "danger",
        });
      });
  },
  methods: {
    transfer() {
      this.processing = true;

      this.$api
        .post("/api/v1/licence/transfer-device", {
          deviceFrom: this.deviceFrom,
          deviceToUid: this.deviceToUid,
        })
        .then(() => {
          this.$router.push("/dispositivo");

          this.$vs.notify({
            time: 6000,
            text: "Licença transferida com sucesso.",
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "success",
          });
        })
        .catch((error) => {
          this.processing = false;

          this.$vs.notify({
            time: 6000,
            title: "Aviso",
            text: error.response.data.error || error.response.data.message,
            iconPack: "feather",
            icon: "icon-alert-circle",
            color: "danger",
          });
        });
    },
  },
};
</script>
